import VerifyEmailLink from 'features/myVaro/screens/PersonalDetails/ChangePhoneNumber/VerifyEmailLink/VerifyEmailLink';
import React from 'react';

export default function CheckEmailPage() {
  return <VerifyEmailLink />;
}
